import mapProps from '../scripts/utils/map-props';
import Tree from './tree';

export default mapProps(
  [
    'selected',
    'expanded',
  ],
  {
    model: {
      prop: 'selected',
      event: 'selectedChange',
    },
  }
)(Tree);
